//
//  ─── GENERAL ACTIONS ────────────────────────────────────────────────────────────
//

// grades load
export const FETCH_GRADES_REQUEST = 'FETCH_GRADES_REQUEST'
export const FETCH_GRADES_SUCCESS = 'FETCH_GRADES_SUCCESS'
export const FETCH_GRADES_FAIL = 'FETCH_GRADES_FAIL'

// levels load
export const FETCH_LEVELS_REQUEST = 'FETCH_LEVELS_REQUEST'
export const FETCH_LEVELS_SUCCESS = 'FETCH_LEVELS_SUCCESS'
export const FETCH_LEVELS_FAIL = 'FETCH_LEVELS_FAIL'

// load academic years
export const FETCH_ACADEMIC_YEARS_REQUEST = 'FETCH_ACADEMIC_YEARS_REQUEST'
export const FETCH_ACADEMIC_YEARS_SUCCESS = 'FETCH_ACADEMIC_YEARS_SUCCESS'
export const FETCH_ACADEMIC_YEARS_FAIL = 'FETCH_ACADEMIC_YEARS_FAIL'

// load Cities
export const FETCH_CITIES_REQUEST = 'FETCH_CITIES_REQUEST'
export const FETCH_CITIES_SUCCESS = 'FETCH_CITIES_SUCCESS'
export const FETCH_CITIES_FAIL = 'FETCH_CITIES_FAIL'
export const FETCH_CITIES_ASYNC_START = 'FETCH_CITIES_ASYNC_START'
export const FETCH_CITIES_ASYNC_END = 'FETCH_CITIES_ASYNC_END'

// load states
export const FETCH_STATES_REQUEST = 'FETCH_STATES_REQUEST'
export const FETCH_STATES_SUCCESS = 'FETCH_STATES_SUCCESS'
export const FETCH_STATES_FAIL = 'FETCH_STATES_FAIL'
export const FETCH_STATES_ASYNC_START = 'FETCH_STATES_ASYNC_START'
export const FETCH_STATES_ASYNC_END = 'FETCH_STATES_ASYNC_END'

// load DISTRICTS
export const FETCH_DISTRICTS_REQUEST = 'FETCH_DISTRICTS_REQUEST'
export const FETCH_DISTRICTS_SUCCESS = 'FETCH_DISTRICTS_SUCCESS'
export const FETCH_DISTRICTS_FAIL = 'FETCH_DISTRICTS_FAIL'
export const FETCH_DISTRICTS_ASYNC_START = 'FETCH_DISTRICTS_ASYNC_START'
export const FETCH_DISTRICTS_ASYNC_END = 'FETCH_DISTRICTS_ASYNC_END'

export const SEND_EMAIL_CONFIRMATION_LINK_REQUEST = 'SEND_EMAIL_CONFIRMATION_LINK_REQUEST'
export const SEND_EMAIL_CONFIRMATION_LINK_SUCCESS = 'SEND_EMAIL_CONFIRMATION_LINK_SUCCESS'
export const SEND_EMAIL_CONFIRMATION_LINK_FAIL = 'SEND_EMAIL_CONFIRMATION_LINK_FAIL'
export const SEND_EMAIL_CONFIRMATION_LINK_ASYNC_START =
  'SEND_EMAIL_CONFIRMATION_LINK_ASYNC_START'
export const SEND_EMAIL_CONFIRMATION_LINK_ASYNC_END =
  'SEND_EMAIL_CONFIRMATION_LINK_ASYNC_END'

export const SEND_SMS_CONFIRMATION_CODE_REQUEST = 'SEND_SMS_CONFIRMATION_CODE_REQUEST'
export const SEND_SMS_CONFIRMATION_CODE_SUCCESS = 'SEND_SMS_CONFIRMATION_CODE_SUCCESS'
export const SEND_SMS_CONFIRMATION_CODE_FAIL = 'SEND_SMS_CONFIRMATION_CODE_FAIL'
export const SEND_SMS_CONFIRMATION_CODE_ASYNC_START =
  'SEND_SMS_CONFIRMATION_CODE_ASYNC_START'
export const SEND_SMS_CONFIRMATION_CODE_ASYNC_END = 'SEND_SMS_CONFIRMATION_CODE_ASYNC_END'

export const VERIFY_EMAIL_REQUEST = 'VERIFY_EMAIL_REQUEST'
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS'
export const VERIFY_EMAIL_FAIL = 'VERIFY_EMAIL_FAIL'
export const VERIFY_EMAIL_ASYNC_START = 'VERIFY_EMAIL_ASYNC_START'
export const VERIFY_EMAIL_ASYNC_END = 'VERIFY_EMAIL_ASYNC_END'

export const VERIFY_PHONE_REQUEST = 'VERIFY_PHONE_REQUEST'
export const VERIFY_PHONE_SUCCESS = 'VERIFY_PHONE_SUCCESS'
export const VERIFY_PHONE_FAIL = 'VERIFY_PHONE_FAIL'
export const VERIFY_PHONE_ASYNC_START = 'VERIFY_PHONE_ASYNC_START'
export const VERIFY_PHONE_ASYNC_END = 'VERIFY_PHONE_ASYNC_END'

//
// ─── AUTHENTICATION ACTIONS ─────────────────────────────────────────────────────
//

// login
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'

// login-as
export const LOGIN_AS_REQUEST = 'LOGIN_AS_REQUEST'
export const LOGIN_AS_SUCCESS = 'LOGIN_AS_SUCCESS'
export const LOGIN_AS_FAIL = 'LOGIN_AS_FAIL'

// logOut
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAIL = 'LOGOUT_FAIL'

// signup
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_FAIL = 'SIGNUP_FAIL'

// reset password
export const RESET_PASS_REQUEST = 'RESET_PASS_REQUEST'
export const RESET_PASS_SUCCESS = 'RESET_PASS_SUCCESS'
export const RESET_PASS_FAIL = 'RESET_PASS_FAIL'

// reset password
export const CONFIRM_RESET_PASS_REQUEST = 'CONFIRM_RESET_PASS_REQUEST'
export const CONFIRM_RESET_PASS_SUCCESS = 'CONFIRM_RESET_PASS_SUCCESS'
export const CONFIRM_RESET_PASS_FAIL = 'CONFIRM_RESET_PASS_FAIL'

// keeping track of authentications
export const AUTH_ASYNC_CALL_START = 'AUTH_ASYNC_CALL_START'
export const AUTH_ASYNC_CALL_END = 'AUTH_ASYNC_CALL_END'

//
// ─── SIDEBAR ACTIONS ────────────────────────────────────────────────────────────
//

// sidebar status
export const SIDEBAR_STATUS_TOGGLE = 'SIDEBAR_STATUS_TOGGLE'
export const SIDEBAR_CLOSE = 'SIDEBAR_CLOSE'

//
// ─── PROFILE ACTIONS ────────────────────────────────────────────────────────────
//

// keeping track of profile updates
export const PROFILE_ASYNC_CALL_START = 'PROFILE_ASYNC_CALL_START'
export const PROFILE_ASYNC_CALL_END = 'PROFILE_ASYNC_CALL_END'
export const PROFILE_MINOR_ASYNC_CALL_START = 'PROFILE_MINOR_ASYNC_CALL_START'
export const PROFILE_MINOR_ASYNC_CALL_END = 'PROFILE_MINOR_ASYNC_CALL_END'

// profile info
export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE'
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS'
export const FETCH_USER_PROFILE_FAIL = 'FETCH_USER_PROFILE_FAIL'
export const FETCH_CONTACTS_INFO = 'FETCH_CONTACTS_INFO'
export const FETCH_CONTACTS_ASYNC_START = 'FETCH_CONTACTS_ASYNC_START'
export const FETCH_CONTACTS_SUCCESS = 'FETCH_CONTACTS_SUCCESS'
export const FETCH_CONTACT_FAIL = 'FETCH_CONTACT_FAIL'
export const FETCH_CONTACT_ASYNC_END = 'FETCH_CONTACT_ASYNC_END'


export const FETCH_USER_PROFILE_DOCUMENTS_GROUP_REQUEST = 'FETCH_USER_PROFILE_DOCUMENTS_GROUP_REQUEST'
export const FETCH_USER_PROFILE_DOCUMENTS_GROUP_SUCCESS = 'FETCH_USER_PROFILE_DOCUMENTS_GROUP_SUCCESS'
export const FETCH_USER_PROFILE_DOCUMENTS_GROUP_FAILURE = 'FETCH_USER_PROFILE_DOCUMENTS_GROUP_FAILURE'

export const UPLOAD_USER_PROFILE_DOCUMENT_REQUEST = 'UPLOAD_USER_PROFILE_DOCUMENT_REQUEST'
export const UPLOAD_USER_PROFILE_DOCUMENT_SUCCESS = 'UPLOAD_USER_PROFILE_DOCUMENT_SUCCESS'
export const UPLOAD_USER_PROFILE_DOCUMENT_FAILURE = 'UPLOAD_USER_PROFILE_DOCUMENT_FAILURE'

export const UPDATE_USER_PROFILE_DOCUMENT_REQUEST = 'UPDATE_USER_PROFILE_DOCUMENT_REQUEST'
export const UPDATE_USER_PROFILE_DOCUMENT_SUCCESS = 'UPDATE_USER_PROFILE_DOCUMENT_SUCCESS'
export const UPDATE_USER_PROFILE_DOCUMENT_FAILURE = 'UPDATE_USER_PROFILE_DOCUMENT_FAILURE'

export const REMOVE_USER_PROFILE_DOCUMENT_REQUEST = 'REMOVE_USER_PROFILE_DOCUMENT_REQUEST'
export const REMOVE_USER_PROFILE_DOCUMENT_SUCCESS = 'REMOVE_USER_PROFILE_DOCUMENT_SUCCESS'
export const REMOVE_USER_PROFILE_DOCUMENT_FAILURE = 'REMOVE_USER_PROFILE_DOCUMENT_FAILURE'


// profile update
export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST'
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS'
export const PROFILE_UPDATE_FAIL = 'PROFILE_UPDATE_FAIL'

// email update
export const EMAIL_CHANGE_REQUEST = 'EMAIL_CHANGE_REQUEST'
export const EMAIL_CHANGE_SUCCESS = 'EMAIL_CHANGE_SUCCESS'
export const EMAIL_CHANGE_FAIL = 'EMAIL_CHANGE_FAIL'

// password update
export const PASSWORD_CHANGE_REQUEST = 'PASSWORD_CHANGE_REQUEST'
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS'
export const PASSWORD_CHANGE_FAIL = 'PASSWORD_CHANGE_FAIL'

//
// ─── STUDENT ACTIONS ────────────────────────────────────────────────────────────
//

// school specific actions
export const IMPORT_STUDENTS_REQUEST = 'IMPORT_STUDENTS_REQUEST'
export const IMPORT_STUDENTS_SUCCESS = 'IMPORT_STUDENTS_SUCCESS'
export const IMPORT_STUDENTS_FAIL = 'IMPORT_STUDENTS_FAIL'
export const IMPORT_STUDENTS_ASYNC_START = 'IMPORT_STUDENTS_ASYNC_START'
export const IMPORT_STUDENTS_ASYNC_END = 'IMPORT_STUDENTS_ASYNC_END'

export const ADD_SINGLE_STUDENT_TO_SCHOOL_REQUEST =
  ' ADD_SINGLE_STUDENT_TO_SCHOOL_REQUEST'
export const ADD_SINGLE_STUDENT_TO_SCHOOL_SUCCESS =
  ' ADD_SINGLE_STUDENT_TO_SCHOOL_SUCCESS'
export const ADD_SINGLE_STUDENT_TO_SCHOOL_FAIL = ' ADD_SINGLE_STUDENT_TO_SCHOOL_FAIL'
export const ADD_SINGLE_STUDENT_TO_SCHOOL_ASYNC_START =
  ' ADD_SINGLE_STUDENT_TO_SCHOOL_ASYNC_START'
export const ADD_SINGLE_STUDENT_TO_SCHOOL_ASYNC_END =
  ' ADD_SINGLE_STUDENT_TO_SCHOOL_ASYNC_END'

export const UPLOAD_STUDENT_DOCUMENT_REQUEST = 'UPLOAD_STUDENT_DOCUMENT_REQUEST'
export const UPLOAD_STUDENT_DOCUMENT_SUCCESS = 'UPLOAD_STUDENT_DOCUMENT_SUCCESS'
export const UPLOAD_STUDENT_DOCUMENT_FAIL = 'UPLOAD_STUDENT_DOCUMENT_FAIL'
export const UPLOAD_STUDENT_DOCUMENT_ASYNC_START = 'UPLOAD_STUDENT_DOCUMENT_ASYNC_START'
export const UPLOAD_STUDENT_DOCUMENT_ASYNC_END = 'UPLOAD_STUDENT_DOCUMENT_ASYNC_END'

export const FETCH_STUDENT_DOCUMENTS_REQUEST = 'FETCH_STUDENT_DOCUMENTS_REQUEST'
export const FETCH_STUDENT_DOCUMENTS_SUCCESS = 'FETCH_STUDENT_DOCUMENTS_SUCCESS'
export const FETCH_STUDENT_DOCUMENTS_FAIL = 'FETCH_STUDENT_DOCUMENTS_FAIL'
export const FETCH_STUDENT_DOCUMENTS_ASYNC_START = 'FETCH_STUDENT_DOCUMENTS_ASYNC_START'
export const FETCH_STUDENT_DOCUMENTS_ASYNC_END = 'FETCH_STUDENT_DOCUMENTS_ASYNC_END'

export const REMOVE_STUDENT_DOCUMENT_REQUEST = 'REMOVE_STUDENT_DOCUMENT_REQUEST'
export const REMOVE_STUDENT_DOCUMENT_SUCCESS = 'REMOVE_STUDENT_DOCUMENT_SUCCESS'
export const REMOVE_STUDENT_DOCUMENT_FAIL = 'REMOVE_STUDENT_DOCUMENT_FAIL'
export const REMOVE_STUDENT_DOCUMENT_ASYNC_START = 'REMOVE_STUDENT_DOCUMENT_ASYNC_START'
export const REMOVE_STUDENT_DOCUMENT_ASYNC_END = 'REMOVE_STUDENT_DOCUMENT_ASYNC_END'

//
// ─── MANAGER SPECIFIC ACTIONS ───────────────────────────────────────────────────
//

export const FETCH_STUDENTS_LIST_REQUEST = 'FETCH_STUDENTS_LIST_REQUEST'
export const FETCH_STUDENTS_LIST_SUCCESS = 'FETCH_STUDENTS_LIST_SUCCESS'
export const FETCH_STUDENTS_LIST_FAIL = 'FETCH_STUDENTS_LIST_FAIL'
export const FETCH_STUDENTS_LIST_ASYNC_START = 'FETCH_STUDENTS_LIST_ASYNC_START'
export const FETCH_STUDENTS_LIST_ASYNC_END = 'FETCH_STUDENTS_LIST_ASYNC_END'
export const TEACHER_SIGNUP_BY_MANAGER_SUCCESS = 'TEACHER_SIGNUP_BY_MANAGER_SUCCESS'
export const SCHOOL_SIGNUP_BY_MANAGER_SUCCESS = 'SCHOOL_SIGNUP_BY_MANAGER_SUCCESS'
export const SUPERVISOR_SIGNUP_BY_MANAGER_SUCCESS = 'SUPERVISOR_SIGNUP_BY_MANAGER_SUCCESS'

export const MANAGER_REMOVE_USER_REQUEST = 'MANAGER_REMOVE_USER_REQUEST'
export const MANAGER_REMOVE_SCHOOL_SUCCESS = 'MANAGER_REMOVE_SCHOOL_SUCCESS'
export const MANAGER_REMOVE_TEACHER_SUCCESS = 'MANAGER_REMOVE_TEACHER_SUCCESS'
export const MANAGER_REMOVE_SUPERVISOR_SUCCESS = 'MANAGER_REMOVE_SUPERVISOR_SUCCESS'
export const MANAGER_REMOVE_APP_SUCCESS = 'MANAGER_REMOVE_APP_SUCCESS'
export const MANAGER_REMOVE_USER_FAIL = 'MANAGER_REMOVE_USER_FAIL'
export const MANAGER_REMOVE_USER_ASYNC_START = 'MANAGER_REMOVE_USER_ASYNC_START'
export const MANAGER_REMOVE_USER_ASYNC_END = 'MANAGER_REMOVE_USER_ASYNC_END'

export const MANAGER_TOGGLE_USER_VERIFICATION_REQUEST =
  'MANAGER_TOGGLE_USER_VERIFICATION_REQUEST'
export const MANAGER_TOGGLE_USER_VERIFICATION_SUCCESS =
  'MANAGER_TOGGLE_USER_VERIFICATION_SUCCESS'
export const MANAGER_TOGGLE_USER_VERIFICATION_FAIL =
  'MANAGER_TOGGLE_USER_VERIFICATION_FAIL'
export const MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_START =
  'MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_START'
export const MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_END =
  'MANAGER_TOGGLE_USER_VERIFICATION_ASYNC_END'

export const FETCH_MANAGER_EMAILS_REQUEST = 'FETCH_MANAGER_EMAILS_REQUEST'
export const FETCH_MANAGER_EMAILS_SUCCESS = 'FETCH_MANAGER_EMAILS_SUCCESS'
export const FETCH_MANAGER_EMAILS_FAIL = 'FETCH_MANAGER_EMAILS_FAIL'
export const FETCH_MANAGER_EMAILS_ASYNC_START = 'FETCH_MANAGER_EMAILS_ASYNC_START'
export const FETCH_MANAGER_EMAILS_ASYNC_END = 'FETCH_MANAGER_EMAILS_ASYNC_END'

export const FETCH_MANAGER_SMS_REQUEST = 'FETCH_MANAGER_SMS_REQUEST'
export const FETCH_MANAGER_SMS_SUCCESS = 'FETCH_MANAGER_SMS_SUCCESS'
export const FETCH_MANAGER_SMS_FAIL = 'FETCH_MANAGER_SMS_FAIL'
export const FETCH_MANAGER_SMS_ASYNC_START = 'FETCH_MANAGER_SMS_ASYNC_START'
export const FETCH_MANAGER_SMS_ASYNC_END = 'FETCH_MANAGER_SMS_ASYNC_END'

export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST'
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS'
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL'
export const SEND_EMAIL_ASYNC_START = 'SEND_EMAIL_ASYNC_START'
export const SEND_EMAIL_ASYNC_END = 'SEND_EMAIL_ASYNC_END'

export const SEND_SMS_REQUEST = 'SEND_SMS_REQUEST'
export const SEND_SMS_SUCCESS = 'SEND_SMS_SUCCESS'
export const SEND_SMS_FAIL = 'SEND_SMS_FAIL'
export const SEND_SMS_ASYNC_START = 'SEND_SMS_ASYNC_START'
export const SEND_SMS_ASYNC_END = 'SEND_SMS_ASYNC_END'

export const FETCH_SINGLE_EMAIL_REQUEST = 'FETCH_SINGLE_EMAIL_REQUEST'
export const FETCH_SINGLE_EMAIL_SUCCESS = 'FETCH_SINGLE_EMAIL_SUCCESS'
export const FETCH_SINGLE_EMAIL_FAIL = 'FETCH_SINGLE_EMAIL_FAIL'
export const FETCH_SINGLE_EMAIL_ASYNC_START = 'FETCH_SINGLE_EMAIL_ASYNC_START'
export const FETCH_SINGLE_EMAIL_ASYNC_END = 'FETCH_SINGLE_EMAIL_ASYNC_END'

export const FETCH_SINGLE_SMS_REQUEST = 'FETCH_SINGLE_SMS_REQUEST'
export const FETCH_SINGLE_SMS_SUCCESS = 'FETCH_SINGLE_SMS_SUCCESS'
export const FETCH_SINGLE_SMS_FAIL = 'FETCH_SINGLE_SMS_FAIL'
export const FETCH_SINGLE_SMS_ASYNC_START = 'FETCH_SINGLE_SMS_ASYNC_START'
export const FETCH_SINGLE_SMS_ASYNC_END = 'FETCH_SINGLE_SMS_ASYNC_END'

//
// ─── SCHOOL ACTIONS ─────────────────────────────────────────────────────────────
//

// for school
export const FETCH_SCHOOL_STUDENTS_REQUEST = 'FETCH_SCHOOL_STUDENTS_REQUEST'
export const FETCH_SCHOOL_STUDENTS_SUCCESS = 'FETCH_SCHOOL_STUDENTS_SUCCESS'
export const FETCH_SCHOOL_STUDENTS_FAIL = 'FETCH_SCHOOL_STUDENTS_FAIL'
export const FETCH_SCHOOL_STUDENTS_ASYNC_START = 'FETCH_SCHOOL_STUDENTS_ASYNC_START'
export const FETCH_SCHOOL_STUDENTS_ASYNC_END = 'FETCH_SCHOOL_STUDENTS_ASYNC_END'

// for manager:
export const FETCH_SCHOOLS_LIST_REQUEST = 'FETCH_SCHOOLS_LIST_REQUEST'
export const FETCH_SCHOOLS_LIST_SUCCESS = 'FETCH_SCHOOLS_LIST_SUCCESS'
export const FETCH_SCHOOLS_LIST_FAIL = 'FETCH_SCHOOLS_LIST_FAIL'
export const FETCH_SCHOOLS_LIST_ASYNC_START = 'FETCH_SCHOOLS_LIST_ASYNC_START'
export const FETCH_SCHOOLS_LIST_ASYNC_END = 'FETCH_SCHOOLS_LIST_ASYNC_END'

export const ADD_STUDENT_TO_SCHOOL_REQUEST = 'ADD_STUDENT_TO_SCHOOL_REQUEST'
export const ADD_STUDENT_TO_SCHOOL_SUCCESS = 'ADD_STUDENT_TO_SCHOOL_SUCCESS'
export const ADD_STUDENT_TO_SCHOOL_FAIL = 'ADD_STUDENT_TO_SCHOOL_FAIL'
export const ADD_STUDENT_TO_SCHOOL_ASYNC_START = 'ADD_STUDENT_TO_SCHOOL_ASYNC_START'
export const ADD_STUDENT_TO_SCHOOL_ASYNC_END = 'ADD_STUDENT_TO_SCHOOL_ASYNC_END'

//  for both school and manager
export const REMOVE_STUDENT_FROM_SCHOOL_REQUEST = 'REMOVE_STUDENT_FROM_SCHOOL_REQUEST'
export const REMOVE_STUDENT_FROM_SCHOOL_SUCCESS = 'REMOVE_STUDENT_FROM_SCHOOL_SUCCESS'
export const REMOVE_STUDENT_FROM_SCHOOL_FAIL = 'REMOVE_STUDENT_FROM_SCHOOL_FAIL'
export const REMOVE_STUDENT_FROM_SCHOOL_ASYNC_START =
  'REMOVE_STUDENT_FROM_SCHOOL_ASYNC_START'
export const REMOVE_STUDENT_FROM_SCHOOL_ASYNC_END = 'REMOVE_STUDENT_FROM_SCHOOL_ASYNC_END'

//
// ─── TEACHER ACTIONS ────────────────────────────────────────────────────────────
//

// for manager
export const FETCH_TEACHERS_LIST_REQUEST = 'FETCH_TEACHERS_LIST_REQUEST'
export const FETCH_TEACHERS_LIST_SUCCESS = 'FETCH_TEACHERS_LIST_SUCCESS'
export const FETCH_TEACHERS_LIST_FAIL = 'FETCH_TEACHERS_LIST_FAIL'
export const FETCH_TEACHERS_LIST_ASYNC_START = 'FETCH_TEACHERS_LIST_ASYNC_START'
export const FETCH_TEACHERS_LIST_ASYNC_END = 'FETCH_TEACHERS_LIST_ASYNC_END'

//
// ─── SUPERVISORS ACTIONS ────────────────────────────────────────────────────────
//

// for manager
export const FETCH_SUPERVISORS_LIST_REQUEST = 'FETCH_SUPERVISORS_LIST_REQUEST'
export const FETCH_SUPERVISORS_LIST_SUCCESS = 'FETCH_SUPERVISORS_LIST_SUCCESS'
export const FETCH_SUPERVISORS_LIST_FAIL = 'FETCH_SUPERVISORS_LIST_FAIL'
export const FETCH_SUPERVISORS_LIST_ASYNC_START = 'FETCH_SUPERVISORS_LIST_ASYNC_START'
export const FETCH_SUPERVISORS_LIST_ASYNC_END = 'FETCH_SUPERVISORS_LIST_ASYNC_END'

export const FETCH_SUPERVISOR_STUDENTS_REQUEST = 'FETCH_SUPERVISOR_STUDENTS_REQUEST'
export const FETCH_SUPERVISOR_STUDENTS_SUCCESS = 'FETCH_SUPERVISOR_STUDENTS_SUCCESS'
export const FETCH_SUPERVISOR_STUDENTS_FAIL = 'FETCH_SUPERVISOR_STUDENTS_FAIL'
export const FETCH_SUPERVISOR_STUDENTS_ASYNC_START =
  'FETCH_SUPERVISOR_STUDENTS_ASYNC_START'
export const FETCH_SUPERVISOR_STUDENTS_ASYNC_END = 'FETCH_SUPERVISOR_STUDENTS_ASYNC_END'

export const REMOVE_STUDENT_FROM_SUPERVISOR_REQUEST =
  'REMOVE_STUDENT_FROM_SUPERVISOR_REQUEST'
export const REMOVE_STUDENT_FROM_SUPERVISOR_SUCCESS =
  'REMOVE_STUDENT_FROM_SUPERVISOR_SUCCESS'
export const REMOVE_STUDENT_FROM_SUPERVISOR_FAIL = 'REMOVE_STUDENT_FROM_SUPERVISOR_FAIL'
export const REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_START =
  'REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_START'
export const REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_END =
  'REMOVE_STUDENT_FROM_SUPERVISOR_ASYNC_END'

export const ADD_STUDENT_TO_SUPERVISOR_REQUEST = 'ADD_STUDENT_TO_SUPERVISOR_REQUEST'
export const ADD_STUDENT_TO_SUPERVISOR_SUCCESS = 'ADD_STUDENT_TO_SUPERVISOR_SUCCESS'
export const ADD_STUDENT_TO_SUPERVISOR_FAIL = 'ADD_STUDENT_TO_SUPERVISOR_FAIL'
export const ADD_STUDENT_TO_SUPERVISOR_ASYNC_START =
  'ADD_STUDENT_TO_SUPERVISOR_ASYNC_START'
export const ADD_STUDENT_TO_SUPERVISOR_ASYNC_END = 'ADD_STUDENT_TO_SUPERVISOR_ASYNC_END'

//
// ─── APPS ACTIONS ───────────────────────────────────────────────────────────────
//

//  for manager
export const FETCH_APPS_LIST_REQUEST = 'FETCH_APPS_LIST_REQUEST'
export const FETCH_APPS_LIST_SUCCESS = 'FETCH_APPS_LIST_SUCCESS'
export const FETCH_APPS_LIST_FAIL = 'FETCH_APPS_LIST_FAIL'
export const FETCH_APPS_LIST_ASYNC_START = 'FETCH_APPS_LIST_ASYNC_START'
export const FETCH_APPS_LIST_ASYNC_END = 'FETCH_APPS_LIST_ASYNC_END'

//
// ─── COMMON ACTIONS ─────────────────────────────────────────────────────────────
//

export const FETCH_USER_MESSAGES_REQUEST = 'FETCH_USER_MESSAGES_REQUEST'
export const FETCH_USER_RECEIVED_MESSAGES_SUCCESS = 'FETCH_USER_RECEIVED_MESSAGES_SUCCESS'
export const FETCH_USER_SENT_MESSAGES_SUCCESS = 'FETCH_USER_SENT_MESSAGES_SUCCESS'
export const FETCH_USER_MESSAGES_FAIL = 'FETCH_USER_MESSAGES_FAIL'
export const FETCH_USER_MESSAGES_ASYNC_START = 'FETCH_USER_MESSAGES_ASYNC_START'
export const FETCH_USER_MESSAGES_ASYNC_END = 'FETCH_USER_MESSAGES_ASYNC_END'

export const FETCH_SINGLE_MESSAGE_REQUEST = 'FETCH_SINGLE_MESSAGE_REQUEST'
export const FETCH_SINGLE_MESSAGE_SUCCESS = 'FETCH_SINGLE_MESSAGE_SUCCESS'
export const FETCH_SINGLE_MESSAGE_FAIL = 'FETCH_SINGLE_MESSAGE_FAIL'
export const FETCH_SINGLE_MESSAGE_ASYNC_START = 'FETCH_SINGLE_MESSAGE_ASYNC_START'
export const FETCH_SINGLE_MESSAGE_ASYNC_END = 'FETCH_SINGLE_MESSAGE_ASYNC_END'

export const FETCH_NEW_MESSAGES_REQUEST = 'FETCH_NEW_MESSAGES_REQUEST'
export const FETCH_NEW_MESSAGES_SUCCESS = 'FETCH_NEW_MESSAGES_SUCCESS'
export const FETCH_NEW_MESSAGES_FAIL = 'FETCH_NEW_MESSAGES_FAIL'

export const SET_SEEN_STATUS_REQUEST = 'SET_SEEN_STATUS_REQUEST'
export const SET_SEEN_STATUS_SUCCESS = 'SET_SEEN_STATUS_SUCCESS'
export const SET_SEEN_STATUS_FAIL = 'SET_SEEN_STATUS_FAIL'

export const SENT_MESSAGE_REQUEST = 'SENT_MESSAGE_REQUEST'
export const SENT_MESSAGE_SUCCESS = 'SENT_MESSAGE_SUCCESS'
export const SENT_MESSAGE_FAIL = 'SENT_MESSAGE_FAIL'
export const SENT_MESSAGE_ASYNC_START = 'SENT_MESSAGE_ASYNC_START'
export const SENT_MESSAGE_ASYNC_END = 'SENT_MESSAGE_ASYNC_END'

export const BROADCAST_MESSAGE_REQUEST = 'BROADCAST_MESSAGE_REQUEST'
export const BROADCAST_MESSAGE_SUCCESS = 'BROADCAST_MESSAGE_SUCCESS'
export const BROADCAST_MESSAGE_FAIL = 'BROADCAST_MESSAGE_FAIL'
export const BROADCAST_MESSAGE_ASYNC_START = 'BROADCAST_MESSAGE_ASYNC_START'
export const BROADCAST_MESSAGE_ASYNC_END = 'BROADCAST_MESSAGE_ASYNC_END'

export const FETCH_BROADCASTS_REQUEST = 'FETCH_BROADCASTS_REQUEST'
export const FETCH_BROADCASTS_SUCCESS = 'FETCH_BROADCASTS_SUCCESS'
export const FETCH_BROADCASTS_FAIL = 'FETCH_BROADCASTS_FAIL'
export const FETCH_BROADCASTS_ASYNC_START = 'FETCH_BROADCASTS_ASYNC_START'
export const FETCH_BROADCASTS_ASYNC_END = 'FETCH_BROADCASTS_ASYNC_END'

export const FETCH_SINGLE_BROADCAST_REQUEST = 'FETCH_SINGLE_BROADCAST_REQUEST'
export const FETCH_SINGLE_BROADCAST_SUCCESS = 'FETCH_SINGLE_BROADCAST_SUCCESS'
export const FETCH_SINGLE_BROADCAST_FAIL = 'FETCH_SINGLE_BROADCAST_FAIL'
export const FETCH_SINGLE_BROADCAST_ASYNC_START = 'FETCH_SINGLE_BROADCAST_ASYNC_START'
export const FETCH_SINGLE_BROADCAST_ASYNC_END = 'FETCH_SINGLE_BROADCAST_ASYNC_END'

export const FETCH_USER_BROADCASTS_REQUEST = 'FETCH_USER_BROADCASTS_REQUEST'
export const FETCH_USER_BROADCASTS_SUCCESS = 'FETCH_USER_BROADCASTS_SUCCESS'
export const FETCH_USER_BROADCASTS_FAIL = 'FETCH_USER_BROADCASTS_FAIL'
export const FETCH_USER_BROADCASTS_ASYNC_START = 'FETCH_USER_BROADCASTS_ASYNC_START'
export const FETCH_USER_BROADCASTS_ASYNC_END = 'FETCH_USER_BROADCASTS_ASYNC_END'

export const FETCH_NEW_BROADCASTS_REQUEST = 'FETCH_NEW_BROADCASTS_REQUEST'
export const FETCH_NEW_BROADCASTS_SUCCESS = 'FETCH_NEW_BROADCASTS_SUCCESS'
export const FETCH_NEW_BROADCASTS_FAIL = 'FETCH_NEW_BROADCASTS_FAIL'
export const FETCH_NEW_BROADCASTS_ASYNC_START = 'FETCH_NEW_BROADCASTS_ASYNC_START'
export const FETCH_NEW_BROADCASTS_ASYNC_END = 'FETCH_NEW_BROADCASTS_ASYNC_END'

export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST'
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS'
export const FETCH_EVENTS_FAIL = 'FETCH_EVENTS_FAIL'
export const FETCH_EVENTS_ASYNC_START = 'FETCH_EVENTS_ASYNC_START'
export const FETCH_EVENTS_ASYNC_END = 'FETCH_EVENTS_ASYNC_END'

export const FETCH_BOUGHT_EVENTS_REQUEST = 'FETCH_BOUGHT_EVENTS_REQUEST'
export const FETCH_BOUGHT_EVENTS_SUCCESS = 'FETCH_BOUGHT_EVENTS_SUCCESS'
export const FETCH_BOUGHT_EVENTS_FAIL = 'FETCH_BOUGHT_EVENTS_FAIL'
export const FETCH_BOUGHT_EVENTS_ASYNC_START = 'FETCH_BOUGHT_EVENTS_ASYNC_START'
export const FETCH_BOUGHT_EVENTS_ASYNC_END = 'FETCH_BOUGHT_EVENTS_ASYNC_END'

export const FETCH_SINGLE_EVENT_REQUEST = 'FETCH_SINGLE_EVENT_REQUEST'
export const FETCH_SINGLE_EVENT_SUCCESS = 'FETCH_SINGLE_EVENT_SUCCESS'
export const FETCH_SINGLE_EVENT_FAIL = 'FETCH_SINGLE_EVENT_FAIL'
export const FETCH_SINGLE_EVENT_ASYNC_START = 'FETCH_SINGLE_EVENT_ASYNC_START'
export const FETCH_SINGLE_EVENT_ASYNC_END = 'FETCH_SINGLE_EVENT_ASYNC_END'

export const FETCH_EVENT_CATEGORIES_REQUEST = 'FETCH_EVENT_CATEGORIES_REQUEST'
export const FETCH_EVENT_CATEGORIES_SUCCESS = 'FETCH_EVENT_CATEGORIES_SUCCESS'
export const FETCH_EVENT_CATEGORIES_FAIL = 'FETCH_EVENT_CATEGORIES_FAIL'
export const FETCH_EVENT_CATEGORIES_ASYNC_START = 'FETCH_EVENT_CATEGORIES_ASYNC_START'
export const FETCH_EVENT_CATEGORIES_ASYNC_END = 'FETCH_EVENT_CATEGORIES_ASYNC_END'

export const ADD_EVENT_REQUEST = 'ADD_EVENT_REQUEST'
export const ADD_EVENT_SUCCESS = 'ADD_EVENT_SUCCESS'
export const ADD_EVENT_FAIL = 'ADD_EVENT_FAIL'
export const ADD_EVENT_ASYNC_START = 'ADD_EVENT_ASYNC_START'
export const ADD_EVENT_ASYNC_END = 'ADD_EVENT_ASYNC_END'

export const EDIT_EVENT_REQUEST = 'EDIT_EVENT_REQUEST'
export const EDIT_EVENT_SUCCESS = 'EDIT_EVENT_SUCCESS'
export const EDIT_EVENT_FAIL = 'EDIT_EVENT_FAIL'
export const EDIT_EVENT_ASYNC_START = 'EDIT_EVENT_ASYNC_START'
export const EDIT_EVENT_ASYNC_END = 'EDIT_EVENT_ASYNC_END'

export const REMOVE_EVENT_REQUEST = 'REMOVE_EVENT_REQUEST'
export const REMOVE_EVENT_SUCCESS = 'REMOVE_EVENT_SUCCESS'
export const REMOVE_EVENT_FAIL = 'REMOVE_EVENT_FAIL'
export const REMOVE_EVENT_ASYNC_START = 'REMOVE_EVENT_ASYNC_START'
export const REMOVE_EVENT_ASYNC_END = 'REMOVE_EVENT_ASYNC_END'

export const CREATE_EVENT_TICKET_ORDER_REQUEST = 'CREATE_EVENT_TICKET_ORDER_REQUEST'
export const CREATE_EVENT_TICKET_ORDER_SUCCESS = 'CREATE_EVENT_TICKET_ORDER_SUCCESS'
export const CREATE_EVENT_TICKET_ORDER_FAIL = 'CREATE_EVENT_TICKET_ORDER_FAIL'
export const CREATE_EVENT_TICKET_ORDER_ASYNC_START =
  'CREATE_EVENT_TICKET_ORDER_ASYNC_START'
export const CREATE_EVENT_TICKET_ORDER_ASYNC_END = 'CREATE_EVENT_TICKET_ORDER_ASYNC_END'

export const FETCH_USER_EVENTS_REQUEST = 'FETCH_USER_EVENTS_REQUEST'
export const FETCH_USER_EVENTS_SUCCESS = 'FETCH_USER_EVENTS_SUCCESS'
export const FETCH_USER_EVENTS_FAIL = 'FETCH_USER_EVENTS_FAIL'
export const FETCH_USER_EVENTS_ASYNC_START = 'FETCH_USER_EVENTS_ASYNC_START'
export const FETCH_USER_EVENTS_ASYNC_END = 'FETCH_USER_EVENTS_ASYNC_END'

export const CHECK_EVENT_TOP_STUDENTS_REQUEST = 'CHECK_EVENT_TOP_STUDENTS_REQUEST'
export const CHECK_EVENT_TOP_STUDENTS_SUCCESS = 'CHECK_EVENT_TOP_STUDENTS_SUCCESS'
export const CHECK_EVENT_TOP_STUDENTS_FAIL = 'CHECK_EVENT_TOP_STUDENTS_FAIL'
export const CHECK_EVENT_TOP_STUDENTS_ASYNC_START = 'CHECK_EVENT_TOP_STUDENTS_ASYNC_START'
export const CHECK_EVENT_TOP_STUDENTS_ASYNC_END = 'CHECK_EVENT_TOP_STUDENTS_ASYNC_END'

export const FETCH_ALL_EVENT_TEMPLATES_REQUEST = 'FETCH_ALL_EVENT_TEMPLATES_REQUEST'
export const FETCH_ALL_EVENT_TEMPLATES_SUCCESS = 'FETCH_ALL_EVENT_TEMPLATES_SUCCESS'
export const FETCH_ALL_EVENT_TEMPLATES_FAIL = 'FETCH_ALL_EVENT_TEMPLATES_FAIL'
export const FETCH_ALL_EVENT_TEMPLATES_ASYNC_START =
  'FETCH_ALL_EVENT_TEMPLATES_ASYNC_START'
export const FETCH_ALL_EVENT_TEMPLATES_ASYNC_END = 'FETCH_ALL_EVENT_TEMPLATES_ASYNC_END'

export const DELETE_EVENT_TICKET_REQUEST = 'DELETE_EVENT_TICKET_REQUEST'
export const DELETE_EVENT_TICKET_SUCCESS = 'DELETE_EVENT_TICKET_SUCCESS'
export const DELETE_EVENT_TICKET_FAIL = 'DELETE_EVENT_TICKET_FAIL'
export const DELETE_EVENT_TICKET_ASYNC_START = 'DELETE_EVENT_TICKET_ASYNC_START'
export const DELETE_EVENT_TICKET_ASYNC_END = 'DELETE_EVENT_TICKET_ASYNC_END'

export const DELETE_EVENT_EXTENSION_REQUEST = 'DELETE_EVENT_EXTENSION_REQUEST'
export const DELETE_EVENT_EXTENSION_SUCCESS = 'DELETE_EVENT_EXTENSION_SUCCESS'
export const DELETE_EVENT_EXTENSION_FAIL = 'DELETE_EVENT_EXTENSION_FAIL'
export const DELETE_EVENT_EXTENSION_ASYNC_START = 'DELETE_EVENT_EXTENSION_ASYNC_START'
export const DELETE_EVENT_EXTENSION_ASYNC_END = 'DELETE_EVENT_EXTENSION_ASYNC_END'

export const RESET_PASSWORD_BY_SMS_REQUEST = 'RESET_PASSWORD_BY_SMS_REQUEST'
export const RESET_PASSWORD_BY_SMS_SUCCESS = 'RESET_PASSWORD_BY_SMS_SUCCESS'
export const RESET_PASSWORD_BY_SMS_FAIL = 'RESET_PASSWORD_BY_SMS_FAIL'
export const RESET_PASSWORD_BY_SMS_ASYNC_START = 'RESET_PASSWORD_BY_SMS_ASYNC_START'
export const RESET_PASSWORD_BY_SMS_ASYNC_END = 'RESET_PASSWORD_BY_SMS_ASYNC_END'

export const CONFIRM_SMS_CODE_REQUEST = 'CONFIRM_SMS_CODE_REQUEST'
export const CONFIRM_SMS_CODE_SUCCESS = 'CONFIRM_SMS_CODE_SUCCESS'
export const CONFIRM_SMS_CODE_FAIL = 'CONFIRM_SMS_CODE_FAIL'
export const CONFIRM_SMS_CODE_ASYNC_START = 'CONFIRM_SMS_CODE_ASYNC_START'
export const CONFIRM_SMS_CODE_ASYNC_END = 'RESET_PASSWORD_BY_SMS_ASYNC_END'

export const FETCH_USER_COURSES_REQUEST = 'FETCH_USER_COURSES_REQUEST'
export const FETCH_USER_COURSES_SUCCESS = 'FETCH_USER_COURSES_SUCCESS'
export const FETCH_USER_COURSES_FAIL = 'FETCH_USER_COURSES_FAIL'
export const FETCH_USER_COURSES_ASYNC_START = 'FETCH_USER_COURSES_ASYNC_START'
export const FETCH_USER_COURSES_ASYNC_END = 'FETCH_USER_COURSES_ASYNC_END'

export const FETCH_COURSE_TOPICS_REQUEST = 'FETCH_COURSE_TOPICS_REQUEST'
export const FETCH_COURSE_TOPICS_SUCCESS = 'FETCH_COURSE_TOPICS_SUCCESS'
export const FETCH_COURSE_TOPICS_FAIL = 'FETCH_COURSE_TOPICS_FAIL'
export const FETCH_COURSE_TOPICS_ASYNC_START = 'FETCH_COURSE_TOPICS_ASYNC_START'
export const FETCH_COURSE_TOPICS_ASYNC_END = 'FETCH_COURSE_TOPICS_ASYNC_END'

export const FETCH_BOUGHT_COURSES_REQUEST = 'FETCH_BOUGHT_COURSES_REQUEST'
export const FETCH_BOUGHT_COURSES_SUCCESS = 'FETCH_BOUGHT_COURSES_SUCCESS'
export const FETCH_BOUGHT_COURSES_FAIL = 'FETCH_BOUGHT_COURSES_FAIL'
export const FETCH_BOUGHT_COURSES_ASYNC_START = 'FETCH_BOUGHT_COURSES_ASYNC_START'
export const FETCH_BOUGHT_COURSES_ASYNC_END = 'FETCH_BOUGHT_COURSES_ASYNC_END'

export const CREATE_COURSE_REQUEST = 'CREATE_COURSE_REQUEST'
export const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS'
export const CREATE_COURSE_FAIL = 'CREATE_COURSE_FAIL'
export const CREATE_COURSE_ASYNC_START = 'CREATE_COURSE_ASYNC_START'
export const CREATE_COURSE_ASYNC_END = 'CREATE_COURSE_ASYNC_END'

export const REMOVE_COURSE_REQUEST = 'REMOVE_COURSE_REQUEST'
export const REMOVE_COURSE_SUCCESS = 'REMOVE_COURSE_SUCCESS'
export const REMOVE_COURSE_FAIL = 'REMOVE_COURSE_FAIL'
export const REMOVE_COURSE_ASYNC_START = 'REMOVE_COURSE_ASYNC_START'
export const REMOVE_COURSE_ASYNC_END = 'REMOVE_COURSE_ASYNC_END'

export const UPDATE_COURSE_INFO_REQUEST = 'UPDATE_COURSE_INFO_REQUEST'
export const UPDATE_COURSE_INFO_SUCCESS = 'UPDATE_COURSE_INFO_SUCCESS'
export const UPDATE_COURSE_INFO_FAIL = 'UPDATE_COURSE_INFO_FAIL'
export const UPDATE_COURSE_INFO_ASYNC_START = 'UPDATE_COURSE_INFO_ASYNC_START'
export const UPDATE_COURSE_INFO_ASYNC_END = 'UPDATE_COURSE_INFO_ASYNC_END'

export const ATTACH_CONTENT_TO_COURSE_REQUEST = 'ATTACH_CONTENT_TO_COURSE_REQUEST'
export const ATTACH_CONTENT_TO_COURSE_SUCCESS = 'ATTACH_CONTENT_TO_COURSE_SUCCESS'
export const ATTACH_CONTENT_TO_COURSE_FAIL = 'ATTACH_CONTENT_TO_COURSE_FAIL'
export const ATTACH_CONTENT_TO_COURSE_ASYNC_START = 'ATTACH_CONTENT_TO_COURSE_ASYNC_START'
export const ATTACH_CONTENT_TO_COURSE_ASYNC_END = 'ATTACH_CONTENT_TO_COURSE_ASYNC_END'

export const REMOVE_CONTENT_FROM_COURSE_REQUEST = 'REMOVE_CONTENT_FROM_COURSE_REQUEST'
export const REMOVE_CONTENT_FROM_COURSE_SUCCESS = 'REMOVE_CONTENT_FROM_COURSE_SUCCESS'
export const REMOVE_CONTENT_FROM_COURSE_FAIL = 'REMOVE_CONTENT_FROM_COURSE_FAIL'
export const REMOVE_CONTENT_FROM_COURSE_ASYNC_START =
  'REMOVE_CONTENT_FROM_COURSE_ASYNC_START'
export const REMOVE_CONTENT_FROM_COURSE_ASYNC_END = 'REMOVE_CONTENT_FROM_COURSE_ASYNC_END'

export const UPDATE_COURSE_CONTENT_REQUEST = 'UPDATE_COURSE_CONTENT_REQUEST'
export const UPDATE_COURSE_CONTENT_SUCCESS = 'UPDATE_COURSE_CONTENT_SUCCESS'
export const UPDATE_COURSE_CONTENT_FAIL = 'UPDATE_COURSE_CONTENT_FAIL'
export const UPDATE_COURSE_CONTENT_ASYNC_START = 'UPDATE_COURSE_CONTENT_ASYNC_START'
export const UPDATE_COURSE_CONTENT_ASYNC_END = 'UPDATE_COURSE_CONTENT_ASYNC_END'

export const FETCH_COURSES_LIST_REQUEST = 'FETCH_COURSES_LIST_REQUEST'
export const FETCH_COURSES_LIST_SUCCESS = 'FETCH_COURSES_LIST_SUCCESS'
export const FETCH_COURSES_LIST_FAIL = 'FETCH_COURSES_LIST_FAIL'
export const FETCH_COURSES_LIST_ASYNC_START = 'FETCH_COURSES_LIST_ASYNC_START'
export const FETCH_COURSES_LIST_ASYNC_END = 'FETCH_COURSES_LIST_ASYNC_END'

export const FETCH_COURSE_CONTENTS_REQUEST = 'FETCH_COURSE_CONTENTS_REQUEST'
export const FETCH_COURSE_CONTENTS_SUCCESS = 'FETCH_COURSE_CONTENTS_SUCCESS'
export const FETCH_COURSE_CONTENTS_FAIL = 'FETCH_COURSE_CONTENTS_FAIL'
export const FETCH_COURSE_CONTENTS_ASYNC_START = 'FETCH_COURSE_CONTENTS_ASYNC_START'
export const FETCH_COURSE_CONTENTS_ASYNC_END = 'FETCH_COURSE_CONTENTS_ASYNC_END'

export const FETCH_SINGLE_CONTENT_REQUEST = 'FETCH_SINGLE_CONTENT_REQUEST'
export const FETCH_SINGLE_CONTENT_SUCCESS = 'FETCH_SINGLE_CONTENT_SUCCESS'
export const FETCH_SINGLE_CONTENT_FAIL = 'FETCH_SINGLE_CONTENT_FAIL'
export const FETCH_SINGLE_CONTENT_ASYNC_START = 'FETCH_SINGLE_CONTENT_ASYNC_START'
export const FETCH_SINGLE_CONTENT_ASYNC_END = 'FETCH_SINGLE_CONTENT_ASYNC_END'

export const CREATE_COURSE_ORDER_REQUEST = 'CREATE_COURSE_ORDER_REQUEST'
export const CREATE_COURSE_ORDER_SUCCESS = 'CREATE_COURSE_ORDER_SUCCESS'
export const CREATE_COURSE_ORDER_FAIL = 'CREATE_COURSE_ORDER_FAIL'
export const CREATE_COURSE_ORDER_ASYNC_START = 'CREATE_COURSE_ORDER_ASYNC_START'
export const CREATE_COURSE_ORDER_ASYNC_END = 'CREATE_COURSE_ORDER_ASYNC_END'

export const MANAGER_REMOVE_COURSE_REQUEST = 'MANAGER_REMOVE_COURSE_REQUEST'
export const MANAGER_REMOVE_COURSE_SUCCESS = 'MANAGER_REMOVE_COURSE_SUCCESS'
export const MANAGER_REMOVE_COURSE_FAIL = 'MANAGER_REMOVE_COURSE_FAIL'
export const MANAGER_REMOVE_COURSE_ASYNC_START = 'MANAGER_REMOVE_COURSE_ASYNC_START'
export const MANAGER_REMOVE_COURSE_ASYNC_END = 'MANAGER_REMOVE_COURSE_ASYNC_END'

export const FETCH_SINGLE_COURSE_REQUEST = 'FETCH_SINGLE_COURSE_REQUEST'
export const FETCH_SINGLE_COURSE_SUCCESS = 'FETCH_SINGLE_COURSE_SUCCESS'
export const FETCH_SINGLE_COURSE_FAIL = 'FETCH_SINGLE_COURSE_FAIL'
export const FETCH_SINGLE_COURSE_ASYNC_START = 'FETCH_SINGLE_COURSE_ASYNC_START'
export const FETCH_SINGLE_COURSE_ASYNC_END = 'FETCH_SINGLE_COURSE_ASYNC_END'

//
// ─── ORDERS ACTIONS ─────────────────────────────────────────────────────────────
//

export const CREATE_ORDER_FOR_SERVICE_REQUEST = 'CREATE_ORDER_FOR_SERVICE_REQUEST'
export const CREATE_ORDER_FOR_SERVICE_SUCCESS = 'CREATE_ORDER_FOR_SERVICE_SUCCESS'
export const CREATE_ORDER_FOR_SERVICE_FAIL = 'CREATE_ORDER_FOR_SERVICE_FAIL'
export const CREATE_ORDER_FOR_SERVICE_ASYNC_START = 'CREATE_ORDER_FOR_SERVICE_ASYNC_START'
export const CREATE_ORDER_FOR_SERVICE_ASYNC_END = 'CREATE_ORDER_FOR_SERVICE_ASYNC_END'

export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST'
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS'
export const UPDATE_ORDER_FAIL = 'UPDATE_ORDER_FAIL'
export const UPDATE_ORDER_ASYNC_START = 'UPDATE_ORDER_ASYNC_START'
export const UPDATE_ORDER_ASYNC_END = 'UPDATE_ORDER_ASYNC_END'

export const APPLY_PROMO_CODE_REQUEST = 'APPLY_PROMO_CODE_REQUEST'
export const APPLY_PROMO_CODE_SUCCESS = 'APPLY_PROMO_CODE_SUCCESS'
export const APPLY_PROMO_CODE_FAIL = 'APPLY_PROMO_CODE_FAIL'
export const APPLY_PROMO_CODE_ASYNC_START = 'APPLY_PROMO_CODE_ASYNC_START'
export const APPLY_PROMO_CODE_ASYNC_END = 'APPLY_PROMO_CODE_ASYNC_END'

export const FETCH_BUY_ORDERS_REQUEST = 'FETCH_BUY_ORDERS_REQUEST'
export const FETCH_BUY_ORDERS_SUCCESS = 'FETCH_BUY_ORDERS_SUCCESS'
export const FETCH_BUY_ORDERS_FAIL = 'FETCH_BUY_ORDERS_FAIL'
export const FETCH_BUY_ORDERS_ASYNC_START = 'FETCH_BUY_ORDERS_ASYNC_START'
export const FETCH_BUY_ORDERS_ASYNC_END = 'FETCH_BUY_ORDERS_ASYNC_END'

export const FETCH_SINGLE_ORDER_REQUEST = 'FETCH_SINGLE_ORDER_REQUEST'
export const FETCH_SINGLE_ORDER_SUCCESS = 'FETCH_SINGLE_ORDER_SUCCESS'
export const FETCH_SINGLE_ORDER_FAIL = 'FETCH_SINGLE_ORDER_FAIL'
export const FETCH_SINGLE_ORDER_ASYNC_START = 'FETCH_SINGLE_ORDER_ASYNC_START'
export const FETCH_SINGLE_ORDER_ASYNC_END = 'FETCH_SINGLE_ORDER_ASYNC_END'

export const PAY_PENDING_ORDER_REQUEST = 'PAY_PENDING_ORDER_REQUEST'
export const PAY_PENDING_ORDER_SUCCESS = 'PAY_PENDING_ORDER_SUCCESS'
export const PAY_PENDING_ORDER_FAIL = 'PAY_PENDING_ORDER_FAIL'
export const PAY_PENDING_ORDER_ASYNC_START = 'PAY_PENDING_ORDER_ASYNC_START'
export const PAY_PENDING_ORDER_ASYNC_END = 'PAY_PENDING_ORDER_ASYNC_END'

export const PAY_ORDER_REQUEST = 'PAY_ORDER_REQUEST'
export const PAY_ORDER_SUCCESS = 'PAY_ORDER_SUCCESS'
export const PAY_ORDER_FAIL = 'PAY_ORDER_FAIL'
export const PAY_ORDER_ASYNC_START = 'PAY_ORDER_ASYNC_START'
export const PAY_ORDER_ASYNC_END = 'PAY_ORDER_ASYNC_END'

export const CANCEL_PENDING_ORDER_REQUEST = 'CANCEL_PENDING_ORDER_REQUEST'
export const CANCEL_PENDING_ORDER_SUCCESS = 'CANCEL_PENDING_ORDER_SUCCESS'
export const CANCEL_PENDING_ORDER_FAIL = 'CANCEL_PENDING_ORDER_FAIL'
export const CANCEL_PENDING_ORDER_ASYNC_START = 'CANCEL_PENDING_ORDER_ASYNC_START'
export const CANCEL_PENDING_ORDER_ASYNC_END = 'CANCEL_PENDING_ORDER_ASYNC_END'

export const FETCH_USER_BALANCE_REQUEST = 'FETCH_USER_BALANCE_REQUEST'
export const FETCH_USER_BALANCE_SUCCESS = 'FETCH_USER_BALANCE_SUCCESS'
export const FETCH_USER_BALANCE_FAIL = 'FETCH_USER_BALANCE_FAIL'
export const FETCH_USER_BALANCE_ASYNC_START = 'FETCH_USER_BALANCE_ASYNC_START'
export const FETCH_USER_BALANCE_ASYNC_END = 'FETCH_USER_BALANCE_ASYNC_END'

export const FETCH_PAYMENT_METHODS_REQUEST = 'FETCH_PAYMENT_METHODS_REQUEST'
export const FETCH_PAYMENT_METHODS_SUCCESS = 'FETCH_PAYMENT_METHODS_SUCCESS'
export const FETCH_PAYMENT_METHODS_FAIL = 'FETCH_PAYMENT_METHODS_FAIL'
export const FETCH_PAYMENT_METHODS_ASYNC_START = 'FETCH_PAYMENT_METHODS_ASYNC_START'
export const FETCH_PAYMENT_METHODS_ASYNC_END = 'FETCH_PAYMENT_METHODS_ASYNC_END'

export const REQUEST_PAYMENT_REQUEST = 'REQUEST_PAYMENT_REQUEST'
export const REQUEST_PAYMENT_SUCCESS = 'REQUEST_PAYMENT_SUCCESS'
export const REQUEST_PAYMENT_FAIL = 'REQUEST_PAYMENT_FAIL'
export const REQUEST_PAYMENT_ASYNC_START = 'REQUEST_PAYMENT_ASYNC_START'
export const REQUEST_PAYMENT_ASYNC_END = 'REQUEST_PAYMENT_ASYNC_END'

export const CONFIRM_PAYMENT_REQUEST = 'CONFIRM_PAYMENT_REQUEST'
export const CONFIRM_PAYMENT_SUCCESS = 'CONFIRM_PAYMENT_SUCCESS'
export const CONFIRM_PAYMENT_FAIL = 'CONFIRM_PAYMENT_FAIL'
export const CONFIRM_PAYMENT_ASYNC_START = 'CONFIRM_PAYMENT_ASYNC_START'
export const CONFIRM_PAYMENT_ASYNC_END = 'CONFIRM_PAYMENT_ASYNC_END'

//
// ─── STATS ACTIONS ──────────────────────────────────────────────────────────────
//

export const FETCH_USER_STATS_REQUEST = 'FETCH_USER_STATS_REQUEST'
export const FETCH_USER_STATS_SUCCESS = 'FETCH_USER_STATS_SUCCESS'
export const FETCH_USER_STATS_FAIL = 'FETCH_USER_STATS_FAIL'
export const FETCH_USER_STATS_ASYNC_START = 'FETCH_USER_STATS_ASYNC_START'
export const FETCH_USER_STATS_ASYNC_END = 'FETCH_USER_STATS_ASYNC_END'

//
// ─── ONLINE TESTS ACTIONS ───────────────────────────────────────────────────────
//

export const CREATE_QUESTION_REQUEST = 'CREATE_QUESTION_REQUEST'
export const CREATE_QUESTION_SUCCESS = 'CREATE_QUESTION_SUCCESS'
export const CREATE_QUESTION_FAIL = 'CREATE_QUESTION_FAIL'
export const CREATE_QUESTION_ASYNC_START = 'CREATE_QUESTION_ASYNC_START'
export const CREATE_QUESTION_ASYNC_END = 'CREATE_QUESTION_ASYNC_END'

export const FETCH_QUESTIONS_LIST_REQUEST = 'FETCH_QUESTIONS_LIST_REQUEST'
export const FETCH_QUESTIONS_LIST_SUCCESS = 'FETCH_QUESTIONS_LIST_SUCCESS'
export const FETCH_QUESTIONS_LIST_FAIL = 'FETCH_QUESTIONS_LIST_FAIL'
export const FETCH_QUESTIONS_LIST_ASYNC_START = 'FETCH_QUESTIONS_LIST_ASYNC_START'
export const FETCH_QUESTIONS_LIST_ASYNC_END = 'FETCH_QUESTIONS_LIST_ASYNC_END'

export const CREATE_TEST_REQUEST = 'CREATE_TEST_REQUEST'
export const CREATE_TEST_SUCCESS = 'CREATE_TEST_SUCCESS'
export const CREATE_TEST_FAIL = 'CREATE_TEST_FAIL'
export const CREATE_TEST_ASYNC_START = 'CREATE_TEST_ASYNC_START'
export const CREATE_TEST_ASYNC_END = 'CREATE_TEST_ASYNC_END'

export const ADD_TOPICS_TO_TEST_REQUEST = 'ADD_TOPICS_TO_TEST_REQUEST'
export const ADD_TOPICS_TO_TEST_SUCCESS = 'ADD_TOPICS_TO_TEST_SUCCESS'
export const ADD_TOPICS_TO_TEST_FAIL = 'ADD_TOPICS_TO_TEST_FAIL'
export const ADD_TOPICS_TO_TEST_ASYNC_START = 'ADD_TOPICS_TO_TEST_ASYNC_START'
export const ADD_TOPICS_TO_TEST_ASYNC_END = 'ADD_TOPICS_TO_TEST_ASYNC_END'

export const ADD_QUESTIONS_TO_TEST_REQUEST = 'ADD_QUESTIONS_TO_TEST_REQUEST'
export const ADD_QUESTIONS_TO_TEST_SUCCESS = 'ADD_QUESTIONS_TO_TEST_SUCCESS'
export const ADD_QUESTIONS_TO_TEST_FAIL = 'ADD_QUESTIONS_TO_TEST_FAIL'
export const ADD_QUESTIONS_TO_TEST_ASYNC_START = 'ADD_QUESTIONS_TO_TEST_ASYNC_START'
export const ADD_QUESTIONS_TO_TEST_ASYNC_END = 'ADD_QUESTIONS_TO_TEST_ASYNC_END'

export const FETCH_ONLINE_TESTS_REQUEST = 'FETCH_ONLINE_TESTS_REQUEST'
export const FETCH_ONLINE_TESTS_SUCCESS = 'FETCH_ONLINE_TESTS_SUCCESS'
export const FETCH_ONLINE_TESTS_FAIL = 'FETCH_ONLINE_TESTS_FAIL'
export const FETCH_ONLINE_TESTS_ASYNC_START = 'FETCH_ONLINE_TESTS_ASYNC_START'
export const FETCH_ONLINE_TESTS_ASYNC_END = 'FETCH_ONLINE_TESTS_ASYNC_END'

export const FETCH_SINGLE_TEST_REQUEST = 'FETCH_SINGLE_TEST_REQUEST'
export const FETCH_SINGLE_TEST_SUCCESS = 'FETCH_SINGLE_TEST_SUCCESS'
export const FETCH_SINGLE_TEST_FAIL = 'FETCH_SINGLE_TEST_FAIL'
export const FETCH_SINGLE_TEST_ASYNC_START = 'FETCH_SINGLE_TEST_ASYNC_START'
export const FETCH_SINGLE_TEST_ASYNC_END = 'FETCH_SINGLE_TEST_ASYNC_END'

export const CREATE_ONLINE_TEST_TICKET_ORDER_REQUEST =
  'CREATE_ONLINE_TEST_TICKET_ORDER_REQUEST'
export const CREATE_ONLINE_TEST_TICKET_ORDER_SUCCESS =
  'CREATE_ONLINE_TEST_TICKET_ORDER_SUCCESS'
export const CREATE_ONLINE_TEST_TICKET_ORDER_FAIL = 'CREATE_ONLINE_TEST_TICKET_ORDER_FAIL'
export const CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_START =
  'CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_START'
export const CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_END =
  'CREATE_ONLINE_TEST_TICKET_ORDER_ASYNC_END'

export const FETCH_USER_TEST_TICKET_ORDERS_REQUEST =
  'FETCH_USER_TEST_TICKET_ORDERS_REQUEST'
export const FETCH_USER_TEST_TICKET_ORDERS_SUCCESS =
  'FETCH_USER_TEST_TICKET_ORDERS_SUCCESS'
export const FETCH_USER_TEST_TICKET_ORDERS_FAIL = 'FETCH_USER_TEST_TICKET_ORDERS_FAIL'
export const FETCH_USER_TEST_TICKET_ORDERS_ASYNC_START =
  'FETCH_USER_TEST_TICKET_ORDERS_ASYNC_START'
export const FETCH_USER_TEST_TICKET_ORDERS_ASYNC_END =
  'FETCH_USER_TEST_TICKET_ORDERS_ASYNC_END'

export const TAKE_THE_TEST_REQUEST = 'TAKE_THE_TEST_REQUEST'
export const TAKE_THE_TEST_SUCCESS = 'TAKE_THE_TEST_SUCCESS'
export const TAKE_THE_TEST_FAIL = 'TAKE_THE_TEST_FAIL'
export const TAKE_THE_TEST_ASYNC_START = 'TAKE_THE_TEST_ASYNC_START'
export const TAKE_THE_TEST_ASYNC_END = 'TAKE_THE_TEST_ASYNC_END'

export const CHECK_TEST_STATUS_REQUEST = 'CHECK_TEST_STATUS_REQUEST'
export const CHECK_TEST_STATUS_SUCCESS = 'CHECK_TEST_STATUS_SUCCESS'
export const CHECK_TEST_STATUS_FAIL = 'CHECK_TEST_STATUS_FAIL'
export const CHECK_TEST_STATUS_ASYNC_START = 'CHECK_TEST_STATUS_ASYNC_START'
export const CHECK_TEST_STATUS_ASYNC_END = 'CHECK_TEST_STATUS_ASYNC_END'

export const STASH_ANSWER_REQUEST = 'STASH_ANSWER_REQUEST'
export const TEST_STARTED = 'TEST_STARTED'
export const LEFT_THE_TEST = 'LEFT_THE_TEST'

export const SUBMIT_ANSWERS_REQUEST = 'SUBMIT_ANSWERS_REQUEST'
export const SUBMIT_ANSWERS_SUCCESS = 'SUBMIT_ANSWERS_SUCCESS'
export const SUBMIT_ANSWERS_FAIL = 'SUBMIT_ANSWERS_FAIL'
export const SUBMIT_ANSWERS_ASYNC_START = 'SUBMIT_ANSWERS_ASYNC_START'
export const SUBMIT_ANSWERS_ASYNC_END = 'SUBMIT_ANSWERS_ASYNC_END'

export const SUBMIT_STASH_IMMEDIATELY_REQUEST = 'SUBMIT_STASH_IMMEDIATELY_REQUEST'
export const SUBMIT_STASH_IMMEDIATELY_SUCCESS = 'SUBMIT_STASH_IMMEDIATELY_SUCCESS'
export const SUBMIT_STASH_IMMEDIATELY_FAIL = 'SUBMIT_STASH_IMMEDIATELY_FAIL'
export const SUBMIT_STASH_IMMEDIATELY_ASYNC_START = 'SUBMIT_STASH_IMMEDIATELY_ASYNC_START'
export const SUBMIT_STASH_IMMEDIATELY_ASYNC_END = 'SUBMIT_STASH_IMMEDIATELY_ASYNC_END'

export const FETCH_TEST_RESULT_REQUEST = 'FETCH_TEST_RESULT_REQUEST'
export const FETCH_TEST_RESULT_SUCCESS = 'FETCH_TEST_RESULT_SUCCESS'
export const FETCH_TEST_RESULT_FAIL = 'FETCH_TEST_RESULT_FAIL'
export const FETCH_TEST_RESULT_ASYNC_START = 'FETCH_TEST_RESULT_ASYNC_START'
export const FETCH_TEST_RESULT_ASYNC_END = 'FETCH_TEST_RESULT_ASYNC_END'

export const STASH_QUESTION_REQUEST = 'STASH_QUESTION_REQUEST'
export const UNSTASH_QUESTION_REQUEST = 'UNSTASH_QUESTION_REQUEST'
export const EMPTY_QUESTION_STASH = 'EMPTY_QUESTION_STASH'

export const FETCH_QUESTION_LIST_FOR_EVENT_MAKER_REQUEST =
  'FETCH_QUESTION_LIST_FOR_EVENT_MAKER_REQUEST'
export const FETCH_QUESTION_LIST_FOR_EVENT_MAKER_SUCCESS =
  'FETCH_QUESTION_LIST_FOR_EVENT_MAKER_SUCCESS'
export const FETCH_QUESTION_LIST_FOR_EVENT_MAKER_FAIL =
  'FETCH_QUESTION_LIST_FOR_EVENT_MAKER_FAIL'
export const FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_START =
  'FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_START'
export const FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_END =
  'FETCH_QUESTION_LIST_FOR_EVENT_MAKER_ASYNC_END'

export const UNSUBMIT_QUESTION_FROM_TEST_REQUEST = 'UNSUBMIT_QUESTION_FROM_TEST_REQUEST'
export const UNSUBMIT_QUESTION_FROM_TEST_SUCCESS = 'UNSUBMIT_QUESTION_FROM_TEST_SUCCESS'
export const UNSUBMIT_QUESTION_FROM_TEST_FAIL = 'UNSUBMIT_QUESTION_FROM_TEST_FAIL'
export const UNSUBMIT_QUESTION_FROM_TEST_ASYNC_START =
  'UNSUBMIT_QUESTION_FROM_TEST_ASYNC_START'
export const UNSUBMIT_QUESTION_FROM_TEST_ASYNC_END =
  'UNSUBMIT_QUESTION_FROM_TEST_ASYNC_END'

export const FETCH_FEATURED_ITEMS_REQUEST = 'FETCH_FEATURED_ITEMS_REQUEST'
export const FETCH_FEATURED_ITEMS_SUCCESS = 'FETCH_FEATURED_ITEMS_SUCCESS'
export const FETCH_FEATURED_ITEMS_FAIL = 'FETCH_FEATURED_ITEMS_FAIL'
export const FETCH_FEATURED_ITEMS_ASYNC_START = 'FETCH_FEATURED_ITEMS_ASYNC_START'
export const FETCH_FEATURED_ITEMS_ASYNC_END = 'FETCH_FEATURED_ITEMS_ASYNC_END'

export const FETCH_SERVICE_STATS_REQUEST = 'FETCH_SERVICE_STATS_REQUEST'
export const FETCH_SERVICE_STATS_SUCCESS = 'FETCH_SERVICE_STATS_SUCCESS'
export const FETCH_SERVICE_STATS_FAIL = 'FETCH_SERVICE_STATS_FAIL'
export const FETCH_SERVICE_STATS_ASYNC_START = 'FETCH_SERVICE_STATS_ASYNC_START'
export const FETCH_SERVICE_STATS_ASYNC_END = 'FETCH_SERVICE_STATS_ASYNC_END'

export const GET_STATIC_PAGE_CONTENT_REQUEST = 'GET_STATIC_PAGE_CONTENT_REQUEST'
export const GET_STATIC_PAGE_CONTENT_SUCCESS = 'GET_STATIC_PAGE_CONTENT_SUCCESS'
export const GET_STATIC_PAGE_CONTENT_FAIL = 'GET_STATIC_PAGE_CONTENT_FAIL'
export const GET_STATIC_PAGE_CONTENT_ASYNC_START = 'GET_STATIC_PAGE_CONTENT_ASYNC_START'
export const GET_STATIC_PAGE_CONTENT_ASYNC_END = 'GET_STATIC_PAGE_CONTENT_ASYNC_END'

export const GET_USER_CERTIFICATES_REQUEST = 'GET_USER_CERTIFICATES_REQUEST'
export const GET_USER_CERTIFICATES_SUCCESS = 'GET_USER_CERTIFICATES_SUCCESS'
export const GET_USER_CERTIFICATES_FAIL = 'GET_USER_CERTIFICATES_FAIL'
export const GET_USER_CERTIFICATES_ASYNC_START = 'GET_USER_CERTIFICATES_ASYNC_START'
export const GET_USER_CERTIFICATES_ASYNC_END = 'GET_USER_CERTIFICATES_ASYNC_END'

export const GET_STATIC_PAGE_HEADER_REQUEST = 'GET_STATIC_PAGE_HEADER_REQUEST'
export const GET_STATIC_PAGE_HEADER_SUCCESS = 'GET_STATIC_PAGE_HEADER_SUCCESS'
export const GET_STATIC_PAGE_HEADER_FAIL = 'GET_STATIC_PAGE_HEADER_FAIL'

//
// ─── SERVICE ACTIONS ────────────────────────────────────────────────────────────
//

export const FETCH_SERVICE_DATA_REQUEST = 'FETCH_SERVICE_DATA_REQUEST'
export const FETCH_SERVICE_DATA_SUCCESS = 'FETCH_SERVICE_DATA_SUCCESS'
export const FETCH_SERVICE_DATA_FAIL = 'FETCH_SERVICE_DATA_FAIL'
export const FETCH_SERVICE_DATA_ASYNC_START = 'FETCH_SERVICE_DATA_ASYNC_START'
export const FETCH_SERVICE_DATA_ASYNC_END = 'FETCH_SERVICE_DATA_ASYNC_END'

//
// ─── SUPPORT TICKETING ACTIONS ──────────────────────────────────────────────────
//
export const FETCH_SUPPORT_TICKETS_REQUEST = 'FETCH_SUPPORT_TICKETS_REQUEST'
export const FETCH_SUPPORT_TICKETS_SUCCESS = 'FETCH_SUPPORT_TICKETS_SUCCESS'
export const FETCH_SUPPORT_TICKETS_FAILURE = 'FETCH_SUPPORT_TICKETS_FAILURE'

export const FETCH_SINGLE_SUPPORT_TICKET_REQUEST = 'FETCH_SINGLE_SUPPORT_TICKET_REQUEST'
export const FETCH_SINGLE_SUPPORT_TICKET_SUCCESS = 'FETCH_SINGLE_SUPPORT_TICKET_SUCCESS'
export const FETCH_SINGLE_SUPPORT_TICKET_FAILURE = 'FETCH_SINGLE_SUPPORT_TICKET_FAILURE'

export const CREATE_SUPPORT_TICKET_REQUEST = 'CREATE_SUPPORT_TICKET_REQUEST'
export const CREATE_SUPPORT_TICKET_SUCCESS = 'CREATE_SUPPORT_TICKET_SUCCESS'
export const CREATE_SUPPORT_TICKET_FAILURE = 'CREATE_SUPPORT_TICKET_FAILURE'

export const CREATE_SUPPORT_TICKET_REPLY_REQUEST = 'CREATE_SUPPORT_TICKET_REPLY_REQUEST'
export const CREATE_SUPPORT_TICKET_REPLY_SUCCESS = 'CREATE_SUPPORT_TICKET_REPLY_SUCCESS'
export const CREATE_SUPPORT_TICKET_REPLY_FAILURE = 'CREATE_SUPPORT_TICKET_REPLY_FAILURE'

// MANGER SPECIFIC
export const EDIT_SUPPORT_TICKET_REQUEST = 'EDIT_SINGLE_SUPPORT_TICKET_REQUEST'
export const EDIT_SUPPORT_TICKET_SUCCESS = 'EDIT_SINGLE_SUPPORT_TICKET_SUCCESS'
export const EDIT_SUPPORT_TICKET_FAILURE = 'EDIT_SINGLE_SUPPORT_TICKET_FAILURE'


// SUPERVISOR ENDPOINTS
export const FETCH_SUPERVISOR_EVENTS_REQUEST = 'FETCH_SUPERVISOR_EVENTS_REQUEST'
export const FETCH_SUPERVISOR_EVENTS_SUCCESS = 'FETCH_SUPERVISOR_EVENTS_SUCCESS'
export const FETCH_SUPERVISOR_EVENTS_FAILURE = 'FETCH_SUPERVISOR_EVENTS_FAILURE'

export const FETCH_SUPERVISOR_EVENT_HOSTS_REQUEST = 'FETCH_SUPERVISOR_EVENT_HOSTS_REQUEST'
export const FETCH_SUPERVISOR_EVENT_HOSTS_SUCCESS = 'FETCH_SUPERVISOR_EVENT_HOSTS_SUCCESS'
export const FETCH_SUPERVISOR_EVENT_HOSTS_FAILURE = 'FETCH_SUPERVISOR_EVENT_HOSTS_FAILURE'

export const FETCH_SUPERVISOR_EVENT_STUDENTS_REQUEST = 'FETCH_SUPERVISOR_EVENT_STUDENTS_REQUEST'
export const FETCH_SUPERVISOR_EVENT_STUDENTS_SUCCESS = 'FETCH_SUPERVISOR_EVENT_STUDENTS_SUCCESS'
export const FETCH_SUPERVISOR_EVENT_STUDENTS_FAILURE = 'FETCH_SUPERVISOR_EVENT_STUDENTS_FAILURE'

export const FETCH_SUPERVISOR_EVENT_SCHOOLS_REQUEST = 'FETCH_SUPERVISOR_EVENT_SCHOOLS_REQUEST'
export const FETCH_SUPERVISOR_EVENT_SCHOOLS_SUCCESS = 'FETCH_SUPERVISOR_EVENT_SCHOOLS_SUCCESS'
export const FETCH_SUPERVISOR_EVENT_SCHOOLS_FAILURE = 'FETCH_SUPERVISOR_EVENT_SCHOOLS_FAILURE'

export const FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_REQUEST = 'FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_REQUEST'
export const FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_SUCCESS = 'FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_SUCCESS'
export const FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_FAILURE = 'FETCH_SUPERVISOR_SCHOOL_EVENT_STUDENTS_FAILURE'

export const FETCH_SUPERVISOR_HOST_REQUEST = 'FETCH_SUPERVISOR_HOST_REQUEST'
export const FETCH_SUPERVISOR_HOST_SUCCESS = 'FETCH_SUPERVISOR_HOST_SUCCESS'
export const FETCH_SUPERVISOR_HOST_FAILURE = 'FETCH_SUPERVISOR_HOST_FAILURE'

export const SUPERVISOR_ADD_HOST_REQUEST = 'SUPERVISOR_ADD_HOST_REQUEST'
export const SUPERVISOR_ADD_HOST_SUCCESS = 'SUPERVISOR_ADD_HOST_SUCCESS'
export const SUPERVISOR_ADD_HOST_FAILURE = 'SUPERVISOR_ADD_HOST_FAILURE'

export const SUPERVISOR_REMOVE_HOST_REQUEST = 'SUPERVISOR_REMOVE_HOST_REQUEST'
export const SUPERVISOR_REMOVE_HOST_SUCCESS = 'SUPERVISOR_REMOVE_HOST_SUCCESS'
export const SUPERVISOR_REMOVE_HOST_FAILURE = 'SUPERVISOR_REMOVE_HOST_FAILURE'

export const EDIT_SUPERVISOR_HOST_REQUEST = 'EDIT_SUPERVISOR_HOST_REQUEST'
export const EDIT_SUPERVISOR_HOST_SUCCESS = 'EDIT_SUPERVISOR_HOST_SUCCESS'
export const EDIT_SUPERVISOR_HOST_FAILURE = 'EDIT_SUPERVISOR_HOST_FAILURE'

export const ADD_STUDENTS_TO_SUPERVISOR_HOST_REQUEST = 'ADD_STUDENTS_TO_SUPERVISOR_HOST_REQUEST'
export const ADD_STUDENTS_TO_SUPERVISOR_HOST_SUCCESS = 'ADD_STUDENTS_TO_SUPERVISOR_HOST_SUCCESS'
export const ADD_STUDENTS_TO_SUPERVISOR_HOST_FAILURE = 'ADD_STUDENTS_TO_SUPERVISOR_HOST_FAILURE'

export const REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_REQUEST = 'REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_REQUEST'
export const REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_SUCCESS = 'REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_SUCCESS'
export const REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_FAILURE = 'REMOVE_STUDENTS_FROM_SUPERVISOR_HOST_FAILURE'

// promo codes
export const FETCH_SINGLE_PROMO_CODE_REQUEST = 'FETCH_SINGLE_PROMO_CODE_REQUEST'
export const FETCH_SINGLE_PROMO_CODE_SUCCESS = 'FETCH_SINGLE_PROMO_CODE_SUCCESS'
export const FETCH_SINGLE_PROMO_CODE_FAILURE = 'FETCH_SINGLE_PROMO_CODE_FAILURE'

export const SUPERVISOR_ADD_PROMO_CODE_REQUEST = 'SUPERVISOR_ADD_PROMO_CODE_REQUEST'
export const SUPERVISOR_ADD_PROMO_CODE_SUCCESS = 'SUPERVISOR_ADD_PROMO_CODE_SUCCESS'
export const SUPERVISOR_ADD_PROMO_CODE_FAILURE = 'SUPERVISOR_ADD_PROMO_CODE_FAILURE'

export const SUPERVISOR_UPDATE_PROMO_CODE_REQUEST = 'SUPERVISOR_UPDATE_PROMO_CODE_REQUEST'
export const SUPERVISOR_UPDATE_PROMO_CODE_SUCCESS = 'SUPERVISOR_UPDATE_PROMO_CODE_SUCCESS'
export const SUPERVISOR_UPDATE_PROMO_CODE_FAILURE = 'SUPERVISOR_UPDATE_PROMO_CODE_FAILURE'

export const SUPERVISOR_FETCH_PROMO_CODES_REQUEST = 'SUPERVISOR_FETCH_PROMO_CODES_REQUEST'
export const SUPERVISOR_FETCH_PROMO_CODES_SUCCESS = 'SUPERVISOR_FETCH_PROMO_CODES_SUCCESS'
export const SUPERVISOR_FETCH_PROMO_CODES_FAILURE = 'SUPERVISOR_FETCH_PROMO_CODES_FAILURE'

export const SUPERVISOR_FETCH_EVENT_DOCUMENTS_REQUEST = 'SUPERVISOR_FETCH_EVENT_DOCUMENTS_REQUEST'
export const SUPERVISOR_FETCH_EVENT_DOCUMENTS_SUCCESS = 'SUPERVISOR_FETCH_EVENT_DOCUMENTS_SUCCESS'
export const SUPERVISOR_FETCH_EVENT_DOCUMENTS_FAILURE = 'SUPERVISOR_FETCH_EVENT_DOCUMENTS_FAILURE'

export const SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_REQUEST = 'SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_REQUEST'
export const SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_SUCCESS = 'SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_SUCCESS'
export const SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_FAILURE = 'SUPERVISOR_FINISH_EVENT_HOSTING_SETUP_FAILURE'

// gamification
export const FETCH_STUDENT_BADGES_REQUEST = 'FETCH_STUDENT_BADGES_REQUEST'
export const FETCH_STUDENT_BADGES_SUCCESS = 'FETCH_STUDENT_BADGES_SUCCESS'
export const FETCH_STUDENT_BADGES_FAILURE = 'FETCH_STUDENT_BADGES_FAILURE'




// WEBPACK FOOTER //
// ./src/actions/actions.js